export function openWindowWithPost(url: URI, data: {}): void {
  const form = document.createElement("form");
  form.target = "_blank";
  form.method = "POST";
  form.action = url.toString();
  form.style.display = "none";

  for (const key in data) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = key;
    input.value = data[key];
    form.appendChild(input);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
}
